import { memo } from 'react';

import VersionInfo from '@/components/VersionInfo';
import { cn } from '@/utils/cn';

import { HideMenuButton } from './components/HideMenuButton';
import { NavMenuItem } from './components/NavMenuItem';
import { NavigationProvider, useNavigationContext } from './context/NavigationContext';
import { useDynamicMenu } from './hooks/useDynamicMenu';

const NavigationContent = memo(function NavigationContent() {
  const { isNavCollapsed, toggleNavCollapse } = useNavigationContext();
  const dynamicMenu = useDynamicMenu();

  return (
    <nav
      className={cn(
        'bg-secondary-600 flex h-full flex-col overflow-x-hidden transition-all duration-100 ease-in-out',
        isNavCollapsed ? 'w-14' : 'w-66'
      )}
      role="navigation"
      aria-label="Main navigation"
    >
      <HideMenuButton isNavCollapsed={isNavCollapsed} toggleNavCollapse={toggleNavCollapse} />
      <div
        className={cn(
          'flex-1 overflow-x-hidden overflow-y-auto',
          isNavCollapsed ? 'nav-scrollbar-collapsed' : 'nav-scrollbar-expanded'
        )}
      >
        <ul className="flex flex-col" role="menubar">
          {dynamicMenu.map((item, index) => {
            return <NavMenuItem key={item.text} item={item} index={index} />;
          })}
        </ul>
      </div>
      <VersionInfo isCollapsed={isNavCollapsed} />
    </nav>
  );
});

export const Navigation = () => {
  return (
    <NavigationProvider>
      <NavigationContent />
    </NavigationProvider>
  );
};
